var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FFBE1D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3751_18417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5502 29.75C24.6045 29.75 29.5583 22.2468 29.5583 15.7419C29.5583 15.531 29.5536 15.3154 29.5442 15.1044C30.5079 14.4075 31.3395 13.5443 32 12.5554C31.1025 12.9547 30.1496 13.2154 29.1739 13.3288C30.2013 12.713 30.9705 11.7455 31.3391 10.6058C30.3726 11.1786 29.3156 11.5827 28.2134 11.8007C27.4708 11.0116 26.489 10.4892 25.4197 10.3141C24.3504 10.139 23.2532 10.3211 22.2977 10.8322C21.3423 11.3432 20.5818 12.1548 20.1338 13.1414C19.6859 14.128 19.5754 15.2347 19.8195 16.2904C17.8625 16.1922 15.9479 15.6838 14.2 14.7982C12.452 13.9126 10.9097 12.6695 9.67297 11.1496C9.0444 12.2333 8.85206 13.5157 9.13503 14.7362C9.418 15.9566 10.1551 17.0235 11.1964 17.72C10.4146 17.6952 9.64998 17.4847 8.96563 17.106V17.1669C8.96492 18.3042 9.3581 19.4066 10.0783 20.2868C10.7985 21.167 11.8013 21.7706 12.9162 21.995C12.1921 22.1932 11.432 22.2221 10.6948 22.0794C11.0095 23.0575 11.6216 23.913 12.4458 24.5264C13.27 25.1398 14.2651 25.4807 15.2923 25.5013C13.5484 26.8712 11.3942 27.6142 9.17656 27.6107C8.78329 27.6101 8.3904 27.586 8 27.5385C10.2529 28.9838 12.8735 29.7514 15.5502 29.75Z",
    fill: "#191713"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3751_18417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.58eb002819678825112e4255b7af250a.svg";
export { ForwardRef as ReactComponent };